import Image from "next/image";
import React from "react";
import { motion } from "framer-motion";

const WarnaLogoCard = ({ title, description, hexCodes, image, direction }) => {
  const variants = {
    hidden: { opacity: 0, x: direction === "left" ? -100 : 100 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { type: "spring", stiffness: 100, damping: 10 },
    },
  };

  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      variants={variants}
      className={`flex flex-col ${
        direction === "left" ? "lg:flex-row" : "lg:flex-row-reverse"
      } justify-between items-stretch gap-10 border-2 lg:border-0 border-[#C4C4C4] p-5 lg:p-0 rounded-3xl`}
    >
      <div className="flex flex-col gap-5 w-full lg:w-2/3 border-0 lg:border-2 border-[#C4C4C4] p-5 lg:p-10 rounded-2xl justify-center">
        <h3 className="w-full text-cust-black font-semibold text-3xl lg:text-6xl text-center lg:text-left">
          {title}
        </h3>
        <p className="text-sm lg:text-base text-justify leading-loose">{description}</p>
        <div className="flex flex-col">
          <div className="flex flex-wrap justify-center lg:justify-start gap-5">
            {hexCodes.map((hex, index) => (
              <div
                key={index}
                className="flex flex-col justify-center items-stretch space-y-5 text-sm md:text-base"
              >
                <div
                  className="aspect-square rounded-2xl"
                  style={{ backgroundColor: hex }}
                />
                <p className="text-center text-cust-dark-gray">
                  HEX | {hex.replace("#", "")}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div
        className={`flex w-full lg:w-1/3 ${
          direction === "left" ? "justify-end" : "justify-start"
        }`}
      >
        <Image
          src={image}
          alt={title}
          className="w-full h-auto md:h-72 lg:h-auto object-cover rounded-2xl"
          width={500}
          height={300}
        />
      </div>
    </motion.div>
  );
};

export default WarnaLogoCard;
